<template>
  <Drawer
    width="400"
    title="编辑客户信息"
    v-model="drawerOpened"
    style="padding: 0"
  >
    <div class="drawer-content">
      <Form
        ref="formItem"
        :model="formItem"
        @submit.native.prevent
        label-position="top"
      >
        <FormItem label="公司名" prop="name">
          <Input v-model="formItem.name" placeholder="输入名字..." />
        </FormItem>
        <FormItem label="简称" prop="abbr">
          <Input v-model="formItem.abbr" placeholder="输入简称..." />
        </FormItem>
        <FormItem label="法人代表" prop="legalRep">
          <Input v-model="formItem.legalRep" placeholder="输入法人代表..." />
        </FormItem>
        <FormItem label="网址" prop="web">
          <Input v-model="formItem.web" placeholder="输入网址..." />
        </FormItem>
        <FormItem label="邮箱" prop="email">
          <Input v-model="formItem.email" placeholder="输入邮箱..." />
        </FormItem>
        <FormItem label="信用代码" prop="creditCode">
          <Input v-model="formItem.creditCode" placeholder="输入信用代码..." />
        </FormItem>
        <FormItem label="参保人数" prop="socialSecurityCount">
          <Input
            v-model="formItem.socialSecurityCount"
            placeholder="输入参保人数..."
          />
        </FormItem>
        <FormItem label="注册资本" prop="regisCapi">
          <Input v-model="formItem.regisCapi" placeholder="输入注册资本..." />
        </FormItem>
        <FormItem label="实缴资本" prop="paidCapi">
          <Input v-model="formItem.paidCapi" placeholder="输入实缴资本..." />
        </FormItem>
        <FormItem label="所属行业" prop="industry">
          <Input v-model="formItem.industry" placeholder="输入所属行业..." />
        </FormItem>
        <FormItem label="所属省份" prop="province">
          <Input v-model="formItem.province" placeholder="输入所属省份..." />
        </FormItem>
        <FormItem label="所属城市" prop="city">
          <Input v-model="formItem.city" placeholder="输入所属城市..." />
        </FormItem>
        <FormItem label="所属区县" prop="dist">
          <Input v-model="formItem.dist" placeholder="输入所属区县..." />
        </FormItem>

        <FormItem style="margin-right: 20px">
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "EditCustomerDetailDrawer",
  data() {
    return {
      drawerOpened: false,
      openedCustomer: null,
      formItem: {
        name: null,
        abbr: null,
        legalRep: null,
        web: null,
        phone: null,
        email: null,
        province: null,
        city: null,
        dist: null,
        creditCode: null,
        companyType: null,
        socialSecurityCount: null,
        regisCapi: null,
        paidCapi: null,
        industry: null,
        regisDate: null,
        provedDate: null,
        regisLoc: null,
        scope: null,
      },
    };
  },
  methods: {
    ...mapActions({
      getDepartmentList: "department/getDepartmentListAction",
      updateCustomer: "customer/updateCustomerAction",
    }),
    openDrawer(customer) {
      this.$refs["formItem"].resetFields();
      this.openedCustomer = customer;
      this.drawerOpened = true;
      this.getDepartmentList({});
      if (customer) {
        this.formItem.name = customer.name;
        this.formItem.abbr = customer.abbr;
        this.formItem.legalRep = customer.legalRep;
        this.formItem.web = customer.web;
        this.formItem.phone = customer.phone;
        this.formItem.email = customer.email;
        this.formItem.province = customer.province;
        this.formItem.city = customer.city;
        this.formItem.dist = customer.dist;
        this.formItem.creditCode = customer.creditCode;
        this.formItem.companyType = customer.companyType;
        this.formItem.socialSecurityCount = customer.socialSecurityCount;
        this.formItem.regisCapi = customer.regisCapi;
        this.formItem.paidCapi = customer.paidCapi;
        this.formItem.industry = customer.industry;
        this.formItem.regisDate = customer.regisDate;
        this.formItem.provedDate = customer.provedDate;
        this.formItem.regisLoc = customer.regisLoc;
        this.formItem.scope = customer.scope;
      }
    },
    async handleSubmit(name) {
      try {
        if (this.openedCustomer) {
          await this.updateCustomer({
            id: this.openedCustomer._id,
            data: this.formItem,
          });
        }
        this.$Message.success("保存成功!");
        this.drawerOpened = false;
      } catch (error) {
        this.$Message.error(`失败: ${error}`);
      }
    },
  },
};
</script>
<style lang="stylus" scoped></style>